import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskChannelsRoute: InvariantJiraRoute = {
	name: 'servicedesk-channels',
	path: '/jira/servicedesk/projects/:projectKey/channels',
	exact: true,
};
